"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CALL_CENTER", {
  enumerable: true,
  get: function get() {
    return _Category.CALL_CENTER;
  }
});
Object.defineProperty(exports, "CRM", {
  enumerable: true,
  get: function get() {
    return _Category.CRM;
  }
});
Object.defineProperty(exports, "DATA_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _Category.DATA_MANAGEMENT;
  }
});
Object.defineProperty(exports, "LIVE_CHAT", {
  enumerable: true,
  get: function get() {
    return _Category.LIVE_CHAT;
  }
});
Object.defineProperty(exports, "SALES", {
  enumerable: true,
  get: function get() {
    return _Category.SALES;
  }
});
Object.defineProperty(exports, "SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _Category.SCHEDULING;
  }
});
Object.defineProperty(exports, "VIDEO", {
  enumerable: true,
  get: function get() {
    return _Category.VIDEO;
  }
});

var _Category = require("../Category");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/superCategoryGroups/Sales.js
// module id = 595
// module chunks = 209 210 211 212 213